export default __webpack_public_path__ + "static/media/google-logo.5d09f2b0.png";